import { put, call, select, takeLatest } from 'redux-saga/effects';
import {
    GET_COMPANIES_REQUEST,
    getCompaniesSuccess,
    getCompaniesFailure
} from '../actions/companies';
import { getCompanies } from '../services/companies';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getCompaniesWorker = function* ({ payload = {} } = {}) {
    try {

        yield call(getAllCompaniesWorker);

    } catch (err) {
        yield put(getCompaniesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getAllCompaniesWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { companies }
        } = yield call(getCompanies, filters, token);

        yield put(getCompaniesSuccess(companies));

    } catch (err) {

        yield put(getCompaniesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [getCompaniesWorker, takeLatest(GET_COMPANIES_REQUEST, getAllCompaniesWorker)];
